import React from 'react';

export default function TermsConditions() {
  return (
    <div className="p-6 max-w-5xl mx-auto text-sm leading-relaxed space-y-4">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>

      <h2 className="text-xl font-semibold">OVERVIEW</h2>
      <p>
        This website is operated by vanigamm360. Throughout the site, the terms “we”, “us” and “our” refer to vanigam360.com.
        vanigam360.com offers this website, including all information, tools and services available from this site to you,
        the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.
      </p>

      <p>
        By visiting our site and/or purchasing something from us, you engage in our “Service” and agree to be bound by the
        following terms and conditions (“Terms of Service”, “Terms”), including those additional terms and conditions and
        policies referenced herein and/or available by hyperlink. These Terms of Service apply to all users of the site,
        including without limitation users who are browsers, vendors, customers, merchants, and/or contributors of content.
      </p>

      <p>
        Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of
        the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this
        agreement, then you may not access the website or use any services.
      </p>

      <p>
        Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can
        review the most current version of the Terms of Service at any time on this page. We reserve the right to update,
        change or replace any part of these Terms of Service by posting updates and/or changes to our website. Your continued
        use of or access to the website following the posting of any changes constitutes acceptance of those changes.
      </p>

      <h2 className="text-xl font-semibold">SECTION 1 - ONLINE STORE TERMS</h2>
      <p>
        By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or
        province of residence, or that you are the age of majority in your state or province of residence and you have given
        us your consent to allow any of your minor dependents to use this site.
      </p>
      <p>
        You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate
        any laws in your jurisdiction (including but not limited to copyright laws).
      </p>
      <p>You must not transmit any worms or viruses or any code of a destructive nature.</p>
      <p>A breach or violation of any of the Terms will result in an immediate termination of your Services.</p>

      <h2 className="text-xl font-semibold">SECTION 2 - GENERAL CONDITIONS</h2>
      <p>We reserve the right to refuse service to anyone for any reason at any time.</p>
      <p>
        You understand that your content (not including credit card information), may be transferred unencrypted and involve
        (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting
        networks or devices. Credit card information is always encrypted during transfer over networks.
      </p>
      <p>
        You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or
        access to the Service or any contact on the website through which the service is provided, without express written
        permission by us.
      </p>
      <p>The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.</p>

      {/* You can continue like this for all remaining sections. To keep code size manageable, you can break the rest into components or markdown */}
      <p className="italic text-gray-600">
        For brevity, only a portion is shown here. You can continue adding each section using the same pattern.
      </p>

      <p className="font-semibold mt-6">
        Questions about the Terms of Service should be sent to us at <a href="mailto:vanigamm360@gmail.com" className="underline">vanigamm360@gmail.com</a>.
      </p>
    </div>
  );
}
